import { Component, OnInit, ElementRef, AfterViewInit, Renderer2, ViewChild, Input } from '@angular/core';

@Component({
  selector: 'dhhp-card-header',
  template: `<mat-card-header #refHeader>
  <ng-content></ng-content>
</mat-card-header>`
})
export class DhhpCardHeaderComponent implements OnInit, AfterViewInit {
  @Input() class:string;
  @ViewChild("refHeader", { read: ElementRef }) refHeader: ElementRef;
  constructor(private el: ElementRef, private renderer: Renderer2) { }

  ngOnInit() {
    if(this.class == undefined) {
      this.class = 'mat-card-header';
    } else {
      this.class = this.class + ' mat-card-header';
    }
  }
  ngAfterViewInit() {
    this.renderer.setAttribute(this.refHeader.nativeElement,'class',this.class);
    this.renderer.setAttribute(this.refHeader.nativeElement,'_ngcontent-c6',"");
    this.renderer.removeChild(this.refHeader.nativeElement,this.refHeader.nativeElement.children[0])
  }
}
